import { render } from "./HeroiconsOutlineTag.vue?vue&type=template&id=388449f0"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTag.vue"]])

export default __exports__